import { atom } from 'jotai';
import { TierInformation } from '../interfaces/clientConfiguration';

export const tierAtom = atom<TierInformation | null>(null);
